import _ from "lodash";

export function isNumeric(value) {
    if (value === '') {
        return false
    }

    if (_.isNull(value) || _.isUndefined(value)) {
        return false
    }
    return !(isNaN(value)) && (typeof value !== "object") &&
        (value != Number.POSITIVE_INFINITY) && (value != Number.NEGATIVE_INFINITY);
}